import { RouteItem } from '@eastcoal/router/types/route'

import { AUCTION_DETAIL_PAGE_PATH } from './constants/path'

export const auctionDetailRoute: RouteItem = {
  title: '场次详情',
  hideInMenu: true,
  path: AUCTION_DETAIL_PAGE_PATH,
  Component: () => import('./index')
}
